import { render } from "./EmailActiveResult.vue?vue&type=template&id=039f9b5d&scoped=true"
import script from "./EmailActiveResult.vue?vue&type=script&lang=js"
export * from "./EmailActiveResult.vue?vue&type=script&lang=js"

import "./EmailActiveResult.vue?vue&type=style&index=0&id=039f9b5d&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039f9b5d"]])

export default __exports__